// extracted by mini-css-extract-plugin
export var header = "_ty-1";
export var maskBottom = "_ty-6";
export var maskMiddle = "_ty-7";
export var maskTop = "_ty-5";
export var root = "_ty-0";
export var scrollDownButton = "_ty-3";
export var scrollDownButtonHidden = "_ty-4";
export var viewport = "_ty-2";